import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const StructureInstructionsPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "StructureInstructionsPopup" */ './Container'),
  'popup'
);
